import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { Flex, FlexCenVer, FlexCol } from '@/UI/styles';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { ImageIcon } from '@/UI/Icons/ImageIcon';

interface PublishToCommunityModalImagesProps {
  onUploadClick: () => void;
  imageError: string | null;
}

// TODO: wire up real upload + asset selection once the backend supports community publishing
const PublishToCommunityModalImages = ({ onUploadClick, imageError }: PublishToCommunityModalImagesProps) => {
  const { t } = useTranslation();

  return (
    <>
      <FlexCol sx={{ gap: 3 }}>
        <FlexCenVer sx={{ justifyContent: 'space-between', gap: 2 }}>
          <FlexCol>
            <Typography variant="body-sm-md">
              {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.THUMBNAIL_LABEL)}
              <span aria-hidden style={imageError ? { color: color.Weavy_Error } : undefined}>
                {' *'}
              </span>
            </Typography>
            <Typography variant="body-sm-rg" color={color.White64_T}>
              {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.RECOMMENDED_SIZE)}
            </Typography>
          </FlexCol>
          <ButtonContained mode="filled-secondary" size="xs" onClick={onUploadClick} sx={{ width: 56, minWidth: 56 }}>
            {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.UPLOAD)}
          </ButtonContained>
        </FlexCenVer>
        <FlexCol
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            height: 216,
            background: color.White04_T,
            border: `1px dashed ${imageError ? color.Weavy_Error_64_T : color.White16_T}`,
            borderRadius: 1,
          }}
        >
          {/* TODO: swap for the design's filled/rounded image illustration; current ImageIcon shape + color fill don't match. */}
          <ImageIcon width={52} height={52} style={{ color: color.White16_T }} />
          <ButtonContained mode="filled-light" size="xs" onClick={onUploadClick}>
            {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.CHOOSE_FROM_GALLERY)}
          </ButtonContained>
        </FlexCol>
        {imageError && (
          <Typography variant="body-sm-rg" color={color.Weavy_Error}>
            {imageError}
          </Typography>
        )}
      </FlexCol>

      <FlexCol sx={{ gap: 3 }}>
        <FlexCenVer sx={{ justifyContent: 'space-between', gap: 2 }}>
          <FlexCol>
            <Typography variant="body-sm-md">
              {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.GALLERY_LABEL)}
            </Typography>
            <Typography variant="body-sm-rg" color={color.White64_T}>
              {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.RECOMMENDED_SIZE)}
            </Typography>
          </FlexCol>
          <ButtonContained mode="filled-secondary" size="xs" onClick={onUploadClick} sx={{ width: 56, minWidth: 56 }}>
            {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.MODAL.IMAGES_STEP.UPLOAD)}
          </ButtonContained>
        </FlexCenVer>
        <Flex sx={{ gap: 1, overflowX: 'auto' }}>
          {[0, 1, 2].map((i) => (
            <FlexCenVer
              key={i}
              sx={{
                width: 160,
                height: 90,
                flexShrink: 0,
                justifyContent: 'center',
                background: color.White04_T,
                border: `1px dashed ${color.White16_T}`,
                borderRadius: 1,
              }}
            >
              <ImageIcon width={24} height={24} style={{ color: color.White16_T }} />
            </FlexCenVer>
          ))}
        </Flex>
      </FlexCol>
    </>
  );
};

export default PublishToCommunityModalImages;
